import { useGetDropboxTokensQuery } from '@account/services';
import { DropboxFolderType } from '@account/types/dropbox';
import { DropboxDisclaimerDialog } from '@components/display/dialogs';
import { MediaBrowserToolbar } from '@components/display/toolbars';
import { usePublicLayoutOptions } from '@components/layout/public';
import { Button } from '@components/utility/buttons';
import { useAuth } from '@hooks/useAuth';
import { RepairdocsGridView } from '@repairdocs/routes/RepairdocsGridView';
import { RepairdocsListView } from '@repairdocs/routes/RepairdocsListView';
import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

export const RepairDocs = () => {
    const [dropboxDisclaimerOpen, setDropboxDisclaimerOpen] = useState(false);
    const [params] = useSearchParams();

    const { data: dropboxTokens, isLoading: isLoadingDropboxTokens } = useGetDropboxTokensQuery();
    const { user } = useAuth();
    const hasRepairs = useMemo(
        () =>
            dropboxTokens?.results.some(
                (token) => token.sync_type === 'repairs' && token.is_active && !token.is_expired
            ),
        [dropboxTokens]
    );

    const view = params.get('view') === 'list' ? 'list' : 'grid';
    const extraToolbar = useMemo(
        () => (
            <MediaBrowserToolbar
                extraButton={
                    !isLoadingDropboxTokens && !hasRepairs && user?.exact_debtor_number ? (
                        <Button fullRounded onClick={() => setDropboxDisclaimerOpen(true)} size="small">
                            <FormattedMessage id="dropbox.connectToDropbox" defaultMessage="Connect to Dropbox" />
                        </Button>
                    ) : null
                }
            />
        ),
        [hasRepairs, isLoadingDropboxTokens, user?.exact_debtor_number]
    );
    usePublicLayoutOptions({ extraToolbar });

    return (
        <>
            <div className="p-[26px] h-full">{view === 'grid' ? <RepairdocsGridView /> : <RepairdocsListView />}</div>
            <DropboxDisclaimerDialog
                folderType={DropboxFolderType.Repairs}
                open={dropboxDisclaimerOpen}
                onClose={() => setDropboxDisclaimerOpen(false)}
            />
        </>
    );
};
